module.exports = __webpack_public_path__ + "img/0Q3B3739_L_WoodMatted_MockedUp.491820a1.jpg";